import "./App.css";
import { TodoCardList } from "@/components/todo-card-list/TodoCardList.tsx";
import { useCallback, useEffect, useState } from "react";
import { TodoService } from "@/services/todo-service.ts";
import { Todo } from "@/components/todo-card/TodoCard.tsx";
import { CreateCard } from "@/components/create-card/CreateCard.tsx";
import { Separator, VStack } from "@chakra-ui/react";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { getApiUrl } from "@/config/api.ts";
import {GoogleLogin, googleLogout} from "@react-oauth/google";
import axios from "axios";

function App() {

  const [user, setUser] = useState<{id: any, name: string, email:string}|undefined>(undefined);
  
  const [cards, setCards] = useState<Todo[]>([]);
  const [connection, setConnection] = useState<HubConnection | null>();
  useEffect(() => {
    if (!user?.id) {
      return;
    }
    const fetchData = async () => {
      const todos = await TodoService.getTodos();
      setCards(todos);
    };
    void fetchData();
  }, [user?.id]);

  const deleteCard = (id: number, cards: Todo[]) => {
    setCards(cards.filter((card) => card.id !== id));
  };

  const updateCard = (id: number, todo: Todo, cards: Todo[]) => {
    setCards(
      cards.map((card) => {
        if (card.id === id) {
          return {
            ...card,
            ...todo,
          };
        }
        return card;
      }),
    );
  };

  const createCard = (todo: Todo, cards: Todo[]) => {
    setCards([todo, ...cards.filter((card) => card.id !== todo.id)]);
  };

  useEffect(() => {
    if (!connection) {
      return;
    }
    connection.on("Connected", (param) => {
      console.log(`Connected ${param}`);
    });

    connection.on("Delete", (param) => {
      console.log(`Delete from online updates ${param}`);
      const todo = param as Todo;
      deleteCard(todo.id, cards);
    });

    connection.on("Update", (param) => {
      console.log(`Update from online updates ${param}`);
      const todo = param as Todo;
      updateCard(todo.id, todo, cards);
    });

    connection.on("Create", (param) => {
      console.log(`Create from online updates ${param}`);
      const todo = param as Todo;
      createCard(todo, cards);
    });
    return () => {
      connection?.off("Connected");
      connection?.off("Delete");
      connection?.off("Update");
      connection?.off("Create");
    };
  }, [connection, cards]);

  const joinTodo = async (): Promise<HubConnection | null> => {
    const connection = new HubConnectionBuilder()
      .withUrl(getApiUrl("websocket"))
      .withAutomaticReconnect()
      .build();

    try {
      await connection.start();
      await connection.invoke("Subscribe");
      return connection;
    } catch (err) {
      console.error(err);
    }
    return null;
  };

  useEffect(() => {
    let connection: HubConnection | null = null;
    joinTodo().then((_hub) => {
      setConnection(_hub);
      connection = _hub;
    });
    return () => {
      void connection?.stop();
    };
  }, []);

  const onUpdateCard = useCallback(
    (todo: Todo) => {
      updateCard(todo.id, todo, cards);
      void TodoService.updateTodo(todo);
    },
    [cards],
  );

  const onCreateCard = useCallback(
    (name: string) => {
      // const fakeId = Date.now();
      // createCard({ id: fakeId, name, isComplete: false }, cards);
      TodoService.createTodo({
        id: 0,
        name,
        isComplete: false,
      }).then((todo) => {
        createCard(todo, cards);
        // updateCard(fakeId, todo, cards);
      });
    },
    [cards],
  );

  const onDeleteCard = useCallback(
    (id: number) => {
      deleteCard(id, cards);
      void TodoService.deleteTodo(id);
    },
    [cards],
  );

  useEffect(() => {
    async function restoreSession() {
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) {
        // setLoading(false);
        return;
      }

      try {
        const res = await axios.post("api/auth/refresh", { refreshToken });
        const accessToken = res.data.accessToken;
        localStorage.setItem("accessToken", accessToken);

        // Можно также извлечь данные пользователя из access token
        const payload = JSON.parse(atob(accessToken.split(".")[1]));
        setUser({ id: payload.sub, email: payload.email, name: payload.name });
      } catch (err) {
        console.log("Session expired");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
      } finally {
        // setLoading(false);
      }
    }

    restoreSession();
  }, []);

  return (
    <>
      <VStack gap={2}>
        {user ? (
            <>
            <div>
              <p>Login in google by {user.email}</p>
              <button onClick={() => { 
                googleLogout();
                localStorage.removeItem("accessToken");
                localStorage.removeItem("refreshToken");
                setUser(undefined); 
              }}>
                Выйти
              </button>
            </div>
              <CreateCard onCreate={onCreateCard} />
              <Separator />
              <TodoCardList
                  cards={cards}
                  onUpdateCard={onUpdateCard}
                  onDeleteClick={onDeleteCard}
              />
            </>
        ) : (
            <GoogleLogin
                onSuccess={async (credentialResponse) => {
                  const idToken = credentialResponse.credential;
                  const url = getApiUrl('auth');
                  const token = await axios.post(url+"/google", {
                    idToken
                  });

                  console.log(token);

                  localStorage.setItem("accessToken", token.data.accessToken);
                  localStorage.setItem("refreshToken", token.data.refreshToken);
                  console.log("Logged in as:", token.data.email);
                  const payload = JSON.parse(atob(token.data.accessToken.split(".")[1]));
                  
                  setUser({
                    id: payload.sub,
                    name: token.data.name,
                    email: token.data.email,
                  });
                }}
                onError={() => console.log('Login Failed')}
            />)}
      </VStack>
    </>
  );
}

export default App;
